'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkHowItWorks.module.css';

export function DevlinkHowItWorks({
  as: _Component = _Builtin.Block,
  showButton = true,
  action = {},
  buttonLabel = 'Browse our Services',
  buttonSlot,
}) {
  return (
    <_Component tag="section">
      <_Builtin.Section
        className={_utils.cx(_styles, 'ht-container', 'lg')}
        grid={{
          type: 'section',
        }}
        tag="div"
      >
        <_Builtin.Heading className={_utils.cx(_styles, 'align-center')} tag="h3">
          {'How HelloTech Works'}
        </_Builtin.Heading>
        <_Builtin.Block className={_utils.cx(_styles, 'large')} tag="div" />
        <_Builtin.Block className={_utils.cx(_styles, 'ht-ordered-grid-3')} tag="div">
          <_Builtin.Block className={_utils.cx(_styles, 'ht-content-item')} tag="div">
            <_Builtin.Block className={_utils.cx(_styles, 'ht-content-item-img')} tag="div">
              <_Builtin.Image
                className={_utils.cx(_styles, 'ht-inner-img', 'ht-fit')}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/66294175fd8224ff69398687_how-it-works-01.png"
              />
            </_Builtin.Block>
            <_Builtin.Block className={_utils.cx(_styles, 'ht-content-item-body', 'align-center')} tag="div">
              <_Builtin.Block className={_utils.cx(_styles, 'small-2')} tag="div" />
              <_Builtin.Heading className={_utils.cx(_styles, 'txt-subheader')} tag="h3">
                {'On time, on your schedule'}
              </_Builtin.Heading>
              <_Builtin.Block className={_utils.cx(_styles, 'small')} tag="div" />
              <_Builtin.Paragraph className={_utils.cx(_styles, 'txt-body-md')}>
                {'It’s fast and easy. Just tell us what you need, your availability and location, and we can arrive as soon as today.'}
              </_Builtin.Paragraph>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, 'ht-ordered-grid-arrow')}
            id={_utils.cx(_styles, 'w-node-_52d2bb94-ac02-775b-eef2-4f2b33f376bc-f210a074')}
            tag="div"
          >
            <_Builtin.Image
              className={_utils.cx(_styles, 'ht-ordered-grid-arrow-img')}
              loading="lazy"
              width="auto"
              height="auto"
              alt=""
              src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/5ffe3f84b92dbbbf4e0d078c_arrow-right.png"
            />
          </_Builtin.Block>
          <_Builtin.Block className={_utils.cx(_styles, 'ht-content-item')} tag="div">
            <_Builtin.Block className={_utils.cx(_styles, 'ht-content-item-img')} tag="div">
              <_Builtin.Image
                className={_utils.cx(_styles, 'ht-inner-img', 'ht-fit')}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/662941756726132e8c6ca957_how-it-works-02.png"
              />
            </_Builtin.Block>
            <_Builtin.Block className={_utils.cx(_styles, 'ht-content-item-body', 'align-center')} tag="div">
              <_Builtin.Block className={_utils.cx(_styles, 'small-2')} tag="div" />
              <_Builtin.Heading className={_utils.cx(_styles, 'txt-subheader')} tag="h3">
                {'The right solution from the right pro'}
              </_Builtin.Heading>
              <_Builtin.Block className={_utils.cx(_styles, 'small')} tag="div" />
              <_Builtin.Paragraph className={_utils.cx(_styles, 'txt-body-md')}>
                {'Based on the details you provided, we’ll find the technician most qualified to perform the service.'}
              </_Builtin.Paragraph>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, 'ht-ordered-grid-arrow')}
            id={_utils.cx(_styles, 'w-node-_52d2bb94-ac02-775b-eef2-4f2b33f376c9-f210a074')}
            tag="div"
          >
            <_Builtin.Image
              className={_utils.cx(_styles, 'ht-ordered-grid-arrow-img')}
              loading="lazy"
              width="auto"
              height="auto"
              alt=""
              src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/5ffe3f84b92dbbbf4e0d078c_arrow-right.png"
            />
          </_Builtin.Block>
          <_Builtin.Block className={_utils.cx(_styles, 'ht-content-item')} tag="div">
            <_Builtin.Block className={_utils.cx(_styles, 'ht-content-item-img')} tag="div">
              <_Builtin.Image
                className={_utils.cx(_styles, 'ht-inner-img', 'ht-fit')}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/66294175ba4f85795a68c2b3_how-it-works-03.png"
              />
            </_Builtin.Block>
            <_Builtin.Block className={_utils.cx(_styles, 'ht-content-item-body', 'align-center')} tag="div">
              <_Builtin.Block className={_utils.cx(_styles, 'small-2')} tag="div" />
              <_Builtin.Heading className={_utils.cx(_styles, 'txt-subheader')} tag="h3">
                {'We’ll take it from here'}
              </_Builtin.Heading>
              <_Builtin.Block className={_utils.cx(_styles, 'small')} tag="div" />
              <_Builtin.Paragraph className={_utils.cx(_styles, 'txt-body-md')}>
                {"Sit back, relax and don’t pay until the job is done. We're committed to your 100% satisfaction."}
              </_Builtin.Paragraph>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
        {showButton ? (
          <_Builtin.Block tag="div">
            <_Builtin.Block className={_utils.cx(_styles, 'large')} tag="div" />
            <_Builtin.Block className={_utils.cx(_styles, 'align-center')} tag="div">
              {buttonSlot}
            </_Builtin.Block>
          </_Builtin.Block>
        ) : null}
      </_Builtin.Section>
    </_Component>
  );
}
